// removed by extract-text-webpack-plugin
module.exports = {"Container":"dropdownmenu__Container__2K7p5","DropdownContent":"dropdownmenu__DropdownContent__1JN-N","DropdownItem":"dropdownmenu__DropdownItem__3aSAT","showDropdown":"dropdownmenu__showDropdown__1ys-i"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Dashboard/MainContent/dropdownmenu.css
// module id = 872
// module chunks = 2